<script>
    import Navbar from './navbar.svelte'
    import NavbarTextIcons from './navbar-text-icons.svelte'
    import HighlightLabels from './highlight-labels.svelte'
    import HighlightLabelText from './highlight-label-text.svelte'

    export let theme
    export let primary
    // export let secondary

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'schedule-background-dark.png' : 'schedule-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <Navbar fill={primary} />
    <NavbarTextIcons />
    <HighlightLabels fill={primary} />
    <HighlightLabelText />
</div>
